module.exports = __webpack_public_path__ + "static/media/nf.3315be59.svg";